import React from "react";
import { Tooltip } from "react-leaflet";

const PREFIX = /^(sa|sl|rx|ia|wf|fa|complex)\s*-\s*/i;

export function labelAcres(a) {
  const n = parseFloat(a);
  if (Number.isNaN(n)) return null;
  if (n >= 10000) return `${Math.round(n / 1000)}k ac`;
  if (n >= 1000) return `${(n / 1000).toFixed(1)}k ac`;
  return `${Math.round(n)} ac`;
}

/** Permanent name chip next to larger fires so members can identify them
 *  without tapping. Only renders when acreage clears the threshold. */
export default function FireNameLabel({ name, acres, minAcres = 250 }) {
  const n = parseFloat(acres);
  if (Number.isNaN(n) || n < minAcres || !name) return null;
  return (
    <Tooltip permanent direction="right" offset={[14, 0]} className="fire-name-label" interactive={false}>
      <span className="fnl-name">{String(name).replace(PREFIX, "")}</span>
    </Tooltip>
  );
}
